import { offset } from 'highcharts';

export const OVERVIEW_WIDGET_DATA = [
  {
    type: 'TEXT_HEADER',
    data: {
      title: 'Lightkeeper Service Scores',
      typographyProps: {
        variant: 'h5',
        fontWeightType: 'bold'
      }
    },
    breakpoints: {
      xxl: '100%',
      xl: '100%',
      lg: '100%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'PIE_CHART',
    enableActionBtn: true,
    dialClickPageType: 'friendliness_dial_topic_page',
    title: 'Friendliness of Staff',
    subTitle: 'Current Year to Date: Friendliness',
    footerText: 'Click on the Dial For Details',
    valueKeyToPlot: 'friendliness_of_staff_rating',
    data: {
      valueRange: {
        min: 1,
        max: 5
      },
      angleRange: {
        start: -160,
        end: 160
      },
      chartType: 'progressGauge',
      centerLabel: {
        label: 0,
        subLabel: ''
      },
      baseSegments: [
        {
          from: -160,
          to: 80,
          color: '#F6D1D3',
          innerSize: 90,
          size: 100
        },
        {
          from: 81,
          to: 160,
          color: '#D1EFD6',
          innerSize: 90,
          size: 100
        }
      ],
      indicatorSegments: [
        {
          value: 4.13,
          size: 105,
          name: 'Test',
          color: '#1EB239',
          innerSize: 80,
          colorRanges: [
            {
              from: 1,
              to: 4.1,
              color: '#E24A4A',
              size: 105
            },
            {
              from: 4.2,
              to: 5,
              color: '#1EB239',
              size: 105
            }
          ]
        }
      ]
    },
    cstData: {
      columns: ['friendliness_of_staff_rating', 'benchmark_value', 'sample_size', 'benchmark_sample_size'],
      metric_data: [[4.02, 3.83, 45, 49]]
    },
    breakpoints: {
      xxl: '25%',
      xl: '25%',
      lg: '25%',
      md: '50%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'PIE_CHART',
    enableActionBtn: true,
    dialClickPageType: 'cleanliness_dial_topic_page',
    title: 'Cleanliness of Room',
    subTitle: 'Current Year to Date: Friendliness',
    footerText: 'Click on the Dial For Details',
    valueKeyToPlot: 'cleanliness_of_room_rating',
    data: {
      valueRange: {
        min: 1,
        max: 5
      },
      angleRange: {
        start: -160,
        end: 160
      },
      chartType: 'progressGauge',
      centerLabel: {
        label: 3.79,
        subLabel: '-0.43'
      },
      baseSegments: [
        {
          from: -160,
          to: 40,
          color: '#F6D1D3',
          innerSize: 90,
          size: 100
        },
        {
          from: 41,
          to: 160,
          color: '#D1EFD6',
          innerSize: 90,
          size: 100
        }
      ],
      indicatorSegments: [
        {
          value: 3.79,
          size: 105,
          name: 'Test',
          color: '#1EB239',
          innerSize: 80,
          colorRanges: [
            {
              from: 1,
              to: 3.5,
              color: '#E24A4A',
              size: 105
            },
            {
              from: 3.6,
              to: 5,
              color: '#1EB239',
              size: 105
            }
          ]
        }
      ]
    },
    cstData: {
      columns: ['cleanliness_of_room_rating', 'benchmark_value', 'sample_size', 'benchmark_sample_size'],
      metric_data: [[3.37, 3.18, 45, 49]]
    },
    breakpoints: {
      xxl: '25%',
      xl: '25%',
      lg: '25%',
      md: '50%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'PIE_CHART',
    enableActionBtn: true,
    dialClickPageType: 'condtion_of_room_dial_topic_page',
    title: 'Condition of Room',
    subTitle: 'Current Year to Date: Friendliness',
    footerText: 'Click on the Dial For Details',
    valueKeyToPlot: 'condition_of_room_rating',
    data: {
      valueRange: {
        min: 1,
        max: 5
      },
      angleRange: {
        start: -160,
        end: 160
      },
      chartType: 'progressGauge',
      centerLabel: {
        label: 3.65,
        subLabel: '-0.06'
      },
      baseSegments: [
        {
          from: -160,
          to: 40,
          color: '#F6D1D3',
          innerSize: 90,
          size: 100
        },
        {
          from: 41,
          to: 160,
          color: '#D1EFD6',
          innerSize: 90,
          size: 100
        }
      ],
      indicatorSegments: [
        {
          value: 3.65,
          size: 105,
          name: 'Test',
          color: '#1EB239',
          innerSize: 80,
          colorRanges: [
            {
              from: 1,
              to: 3.5,
              color: '#E24A4A',
              size: 105
            },
            {
              from: 3.6,
              to: 5,
              color: '#1EB239',
              size: 105
            }
          ]
        }
      ]
    },
    cstData: {
      columns: ['condition_of_room_rating', 'benchmark_value', 'sample_size', 'benchmark_sample_size'],
      metric_data: [[3.15, 2.91, 45, 49]]
    },
    breakpoints: {
      xxl: '25%',
      xl: '25%',
      lg: '25%',
      md: '50%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'PIE_CHART',
    enableActionBtn: true,
    dialClickPageType: 'online_review_rating_dial_topic_page',
    title: 'Online Review Rating',
    subTitle: 'Current Year to Date: Friendliness',
    footerText: 'Click on the Dial For Details',
    valueKeyToPlot: 'online_review_rating',
    data: {
      valueRange: {
        min: 1,
        max: 5
      },
      angleRange: {
        start: -160,
        end: 160
      },
      chartType: 'progressGauge',
      centerLabel: {
        label: 2,
        subLabel: '+0.02'
      },
      baseSegments: [
        {
          from: -160,
          to: 40,
          color: '#F6D1D3',
          innerSize: 90,
          size: 100
        },
        {
          from: 41,
          to: 160,
          color: '#D1EFD6',
          innerSize: 90,
          size: 100
        }
      ],
      indicatorSegments: [
        {
          value: 2,
          size: 105,
          name: 'Test',
          color: '#1EB239',
          innerSize: 80,
          colorRanges: [
            {
              from: 1,
              to: 3.5,
              color: '#E24A4A',
              size: 105
            },
            {
              from: 3.6,
              to: 5,
              color: '#1EB239',
              size: 105
            }
          ]
        }
      ]
    },
    cstData: {
      columns: ['online_review_rating', 'benchmark_value', 'sample_size', 'benchmark_sample_size'],
      metric_data: [[3.17, 2.68, 159, 163]]
    },
    breakpoints: {
      xxl: '25%',
      xl: '25%',
      lg: '25%',
      md: '50%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'ADDITIONAL_METRICS_COMPARISON_CHART',
    title: 'Additional Metrics - Everything Working?',
    subTitle: 'Time Period: Current Year to Date',
    enableActionBtn: true,
    footerText: 'Click on the Bars For Details',
    data: {
      exporting: {
        enabled: false
      },
      chart: {
        type: 'bar',
        margin: [50, 0, 80, 75]
      },
      title: {
        text: '',
        align: 'left'
      },
      xAxis: {
        categories: ['Yes', 'No'],
        offset: 10,
        title: {
          text: 'Everything working?',
          align: 'middle',
          offset: 52,
          rotation: -90,
          y: 0,
          style: {
            fontWeight: '600'
          }
        },
        lineColor: '#CCCCCC',
        lineWidth: 0,
        labels: {
          style: {
            fontWeight: '300'
          }
        }
      },
      yAxis: {
        min: 0,
        maxPadding: 0.1,
        labels: {
          style: {
            fontWeight: '300'
          }
        },
        lineWidth: 0,
        title: {
          text: 'Percentage %',
          align: 'middle',
          rotation: 0,
          offset: 10,
          y: 35,
          style: {
            fontWeight: 'bold'
          }
        }
      },
      legend: {
        symbolHeight: 0,
        symbolWidth: 0,
        symbolRadius: 0
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            align: 'left',
            fontSize: '40px',
            x: 5,
            inside: false,
            style: {
              color: 'black',
              fontWeight: '400',
              fontSize: '12px',
              textOutline: '1px contrast'
            }
          },
          minPointLength: 10,
          pointPadding: 0.12,
          groupPadding: 0.12
        }
      },
      series: [
        {
          name: '',
          data: [74, 27],
          color: '#5E68CB'
        }
      ],
      credits: {
        enabled: false
      }
    },
    cstData: {
      columns: ['yes_percentage', 'no_percentage', 'yes_count', 'no_count'],
      metric_data: [[48.88, 51.11, 22, 23]]
    },
    breakpoints: {
      xxl: '50%',
      xl: '50%',
      lg: '50%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'ADDITIONAL_METRICS_COMPARISON_CHART',
    title: 'Additional Metrics - Felt Safe & Secure?',
    subTitle: 'Time Period: Current Year to Date',
    enableActionBtn: true,
    footerText: 'Click on the Bars For Details',
    data: {
      exporting: {
        enabled: false
      },
      chart: {
        type: 'bar',
        margin: [50, 0, 80, 75]
      },
      title: {
        text: '',
        align: 'left'
      },
      xAxis: {
        categories: ['Yes', 'No'],
        offset: 10,
        title: {
          text: 'Everything working?',
          align: 'middle',
          offset: 52,
          rotation: -90,
          y: 0,
          style: {
            fontWeight: '600'
          }
        },
        lineColor: '#CCCCCC',
        lineWidth: 0,
        labels: {
          style: {
            fontWeight: '300'
          }
        }
      },
      yAxis: {
        min: 0,
        maxPadding: 0.1,
        labels: {
          style: {
            fontWeight: '300'
          }
        },
        lineWidth: 0,
        title: {
          text: 'Percentage %',
          align: 'middle',
          rotation: 0,
          offset: 10,
          y: 35,
          style: {
            fontWeight: 'bold'
          }
        }
      },
      legend: {
        symbolHeight: 0,
        symbolWidth: 0,
        symbolRadius: 0
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            align: 'left',
            fontSize: '40px',
            x: 5,
            inside: false,
            style: {
              color: 'black',
              fontWeight: '400',
              fontSize: '12px',
              textOutline: '1px contrast'
            }
          },
          minPointLength: 10,
          pointPadding: 0.12,
          groupPadding: 0.12
        }
      },
      series: [
        {
          name: '',
          data: [80, 19],
          color: '#5E68CB'
        }
      ],
      credits: {
        enabled: false
      }
    },
    cstData: {
      columns: ['yes_percentage', 'no_percentage', 'yes_count', 'no_count'],
      metric_data: [[65.9, 34.09, 29, 15]]
    },
    breakpoints: {
      xxl: '50%',
      xl: '50%',
      lg: '50%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'NET_PROMOTER_SCORE',
    enableActionBtn: true,
    dialClickPageType: 'nps_dial_topic_page',
    title: 'Net Promoter Score',
    subTitle: 'Current Year to Date: Friendliness',
    footerText: 'Click on the Dial For Details',
    data: {
      valueRange: {
        min: -100,
        max: 100
      },
      angleRange: {
        start: -160,
        end: 160
      },
      chartType: 'performanceGauge',
      centerLabel: {
        label: 3.12,
        subLabel: '-3.10'
      },
      baseSegments: [
        {
          from: -160,
          to: 0,
          color: '#F6D1D3',
          innerSize: 90,
          size: 100
        },
        {
          from: 0,
          to: 160,
          color: '#D1EFD6',
          innerSize: 90,
          size: 100
        }
      ],
      indicatorSegments: [
        {
          value: 8.12,
          size: 105,
          name: 'Test',
          color: '#1EB239',
          innerSize: 80,
          colorRanges: [
            {
              from: -100,
              to: 0,
              color: '#E24A4A',
              size: 105
            },
            {
              from: 1e-8,
              to: 100,
              color: '#1EB239',
              size: 105
            }
          ]
        }
      ]
    },
    cstData: {
      columns: [
        'promoter_percentage',
        'detractor_percentage',
        'passive_percentage',
        'promoter_count',
        'detractor_count',
        'passive_count',
        'average_nps',
        'benchmark_average_nps'
      ],
      metric_data: [[37.77, 51.11, 11.11, 17, 23, 5, -13, -13]]
    },
    breakpoints: {
      xxl: '50%',
      xl: '50%',
      lg: '50%',
      md: '50%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'PIE_CHART',
    enableActionBtn: true,
    dialClickPageType: 'overall_survey_dial_topic_page',
    title: 'Survey: Overall Stay Rating',
    subTitle: 'Current Year to Date: Friendliness',
    footerText: 'Click on the Dial For Details',
    valueKeyToPlot: 'survey_overall_stay_rating',
    data: {
      valueRange: {
        min: 1,
        max: 5
      },
      angleRange: {
        start: -160,
        end: 160
      },
      chartType: 'progressGauge',
      centerLabel: {
        label: 3.55,
        subLabel: '-0.06'
      },
      baseSegments: [
        {
          from: -160,
          to: 40,
          color: '#F6D1D3',
          innerSize: 90,
          size: 100
        },
        {
          from: 41,
          to: 160,
          color: '#D1EFD6',
          innerSize: 90,
          size: 100
        }
      ],
      indicatorSegments: [
        {
          value: 3.55,
          size: 105,
          name: 'Test',
          color: '#1EB239',
          innerSize: 80,
          colorRanges: [
            {
              from: 1,
              to: 3.5,
              color: '#E24A4A',
              size: 105
            },
            {
              from: 3.6,
              to: 5,
              color: '#1EB239',
              size: 105
            }
          ]
        }
      ]
    },
    cstData: {
      columns: ['survey_overall_stay_rating', 'benchmark_value', 'sample_size', 'benchmark_sample_size'],
      metric_data: [[2.91, 2.82, 45, 51]]
    },
    breakpoints: {
      xxl: '50%',
      xl: '50%',
      lg: '50%',
      md: '50%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'TEXT_HEADER',
    data: {
      title: 'Top 5 & Bottom 5 Properties',
      typographyProps: {
        variant: 'h5',
        fontWeightType: 'bold'
      }
    },
    breakpoints: {
      xxl: '100%',
      xl: '100%',
      lg: '100%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'TOP_5_PROPERTIES',
    title: 'Top 5 Properties',
    subTitle: 'Current Year to Date | Benchmark: Same Period Year Ago',
    enableActionBtn: true,
    enableSwitchTabs: true,
    switchOptions: ['BAR', 'TABLE', 'TIME'],
    data: {
      table_data: {
        table_columns: [
          {
            field: 'rank',
            label: 'Rank'
          },
          {
            field: 'property',
            label: 'Property'
          },
          {
            field: 'hash_of_records',
            label: '# of Records'
          },
          {
            field: 'online_score',
            label: 'Online Review Score'
          }
        ],
        table_rows: [
          {
            rank: '1',
            property: 'QARN',
            hash_of_records: '32',
            online_score: 3.53
          },
          {
            rank: '2',
            property: 'QANS',
            hash_of_records: '27',
            online_score: 3.45
          },
          {
            rank: '3',
            property: '2DN',
            hash_of_records: '22',
            online_score: 3.4
          },
          {
            rank: '4',
            property: '2DS',
            hash_of_records: '13',
            online_score: 3.35
          },
          {
            rank: '5',
            property: 'QARS',
            hash_of_records: '15',
            online_score: 3.3
          }
        ],
        sortColumns: ['hash_of_records', 'online_score', 'property']
      },
      chart_data: {
        exporting: {
          enabled: false
        },
        chart: {
          type: 'bar',
          margin: [50, 0, 60, 170]
        },
        title: {
          text: '',
          align: 'left'
        },
        xAxis: {
          categories: [],
          title: {
            text: 'Property',
            align: 'middle',
            offset: 160,
            rotation: -90,
            y: 0,
            style: {
              fontWeight: '600'
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Online Review Score',
            align: 'middle',
            rotation: 0,
            offset: 45,
            style: {
              fontWeight: 'bold'
            }
          }
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              align: 'left',
              fontSize: '40px',
              x: 5,
              inside: false,
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: '12px',
                textOutline: '1px contrast'
              }
            },
            minPointLength: 10,
            pointPadding: 0.1,
            groupPadding: 0.1,
            showInLegend: false
          }
        },
        series: [
          {
            data: [],
            color: '#5E68CB'
          }
        ],
        credits: {
          enabled: false
        }
      },
      graph_table_data: {
        table_data: {
          table_columns: [
            {
              field: 'rank',
              label: 'Rank'
            },
            {
              field: 'property',
              label: 'Property'
            },
            {
              field: 'hash_of_records',
              label: '# of Records'
            },
            {
              field: 'aug',
              label: 'Aug'
            },
            {
              field: 'sep',
              label: 'Sep'
            },
            {
              field: 'oct',
              label: 'Oct'
            },
            {
              field: 'nov',
              label: 'Nov'
            },
            {
              field: 'total',
              label: 'Total'
            },
            {
              field: 'benchmark',
              label: 'Benchmark'
            },
            {
              field: 'delta',
              label: 'Delta'
            }
          ],
          table_rows: [
            {
              rank: '1',
              aug: 1748,
              sep: 3047,
              oct: 3211,
              nov: 782,
              total: 8788,
              benchmark: 8878,
              delta: -90,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [1, 5, 1, 2]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 2,
              aug: 2.88,
              sep: 3.6,
              oct: 2.5,
              nov: 3.71,
              total: 3,
              benchmark: 3.58,
              delta: -0.58,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [2, 4, 6, 3]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 3,
              aug: 3.51,
              sep: 3.32,
              oct: 3.29,
              nov: 2.92,
              total: 3.31,
              benchmark: 3.11,
              delta: 0.2,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [3, 1, 4, 2]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 4,
              aug: 3.05,
              sep: 3.1,
              oct: 3,
              nov: 3.22,
              total: 3.06,
              benchmark: 2.68,
              delta: 0.39,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [5, 2, 8, 4]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 5,
              aug: 3.45,
              sep: 3.39,
              oct: 3.36,
              nov: 3.23,
              total: 3.38,
              benchmark: 3.18,
              delta: 0.2,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [10, 6, 4, 8]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            }
          ]
        }
      }
    },
    cstData: {
      columns: ['rank', 'property', 'No of records', 'Total', 'Benchmark', 'Delta', '2025-08', '2025-09', '2025-10'],
      metric_data: [
        [1, 'STOCKTON, CA', 58, 3.49, 3.53, -0.04, 5, 3.41, 3.27],
        [2, 'PUEBLO - I-25, CO', 101, 3, 2.39, 0.61, 1.95, 2.52, 3.31]
      ]
    },
    breakpoints: {
      xxl: '50%',
      xl: '50%',
      lg: '50%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'BOTTOM_5_PROPERTIES',
    title: 'Bottom 5 Properties',
    subTitle: 'Last 90 Days | Benchmark: Same Period Year Ago',
    enableActionBtn: true,
    enableSwitchTabs: true,
    switchOptions: ['BAR', 'TABLE', 'TIME'],
    data: {
      table_data: {
        table_columns: [
          {
            field: 'rank',
            label: 'Rank'
          },
          {
            field: 'property',
            label: 'Property'
          },
          {
            field: 'hash_of_records',
            label: '# of Records'
          },
          {
            field: 'online_score',
            label: 'Online Review Score'
          }
        ],
        table_rows: [
          {
            rank: '1',
            property: 'QARN',
            hash_of_records: '32',
            online_score: 3.53
          },
          {
            rank: '2',
            property: 'QANS',
            hash_of_records: '27',
            online_score: 3.45
          },
          {
            rank: '3',
            property: '2DN',
            hash_of_records: '22',
            online_score: 3.4
          },
          {
            rank: '4',
            property: '2DS',
            hash_of_records: '13',
            online_score: 3.35
          },
          {
            rank: '5',
            property: 'QARS',
            hash_of_records: '15',
            online_score: 3.3
          }
        ],
        sortColumns: ['hash_of_records', 'online_score', 'property']
      },
      chart_data: {
        exporting: {
          enabled: false
        },
        chart: {
          type: 'bar',
          margin: [50, 0, 60, 170]
        },
        title: {
          text: '',
          align: 'left'
        },
        xAxis: {
          categories: [
            'S65324 HUMBLE,TX',
            '67493 SUMMERVILLE',
            '434 GRANTS,TM',
            '483 OAKLAND, CA',
            '3455 HORNEPAYNE, ONTARIO'
          ],
          title: {
            text: 'Property',
            align: 'middle',
            offset: 160,
            rotation: -90,
            y: 0,
            style: {
              fontWeight: '600'
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Online Review Score',
            align: 'middle',
            rotation: 0,
            offset: 45,
            style: {
              fontWeight: 'bold'
            }
          }
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              align: 'left',
              fontSize: '40px',
              x: 5,
              inside: false,
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: '12px',
                textOutline: '1px contrast'
              }
            },
            minPointLength: 10,
            pointPadding: 0.1,
            groupPadding: 0.1,
            showInLegend: false
          }
        },
        series: [
          {
            data: [74, 27, 56, 2, 50],
            color: '#5E68CB'
          }
        ],
        credits: {
          enabled: false
        }
      },
      graph_table_data: {
        table_data: {
          table_columns: [
            {
              field: 'rank',
              label: 'Rank'
            },
            {
              field: 'property',
              label: 'Property'
            },
            {
              field: 'hash_of_records',
              label: '# of Records'
            },
            {
              field: 'aug',
              label: 'Aug'
            },
            {
              field: 'sep',
              label: 'Sep'
            },
            {
              field: 'oct',
              label: 'Oct'
            },
            {
              field: 'nov',
              label: 'Nov'
            },
            {
              field: 'total',
              label: 'Total'
            },
            {
              field: 'benchmark',
              label: 'Benchmark'
            },
            {
              field: 'delta',
              label: 'Delta'
            }
          ],
          table_rows: [
            {
              rank: '1',
              aug: 1748,
              sep: 3047,
              oct: 3211,
              nov: 782,
              total: 8788,
              benchmark: 8878,
              delta: -90,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [1, 5, 1, 2]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 2,
              aug: 2.88,
              sep: 3.6,
              oct: 2.5,
              nov: 3.71,
              total: 3,
              benchmark: 3.58,
              delta: -0.58,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [2, 4, 6, 3]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 3,
              aug: 3.51,
              sep: 3.32,
              oct: 3.29,
              nov: 2.92,
              total: 3.31,
              benchmark: 3.11,
              delta: 0.2,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [3, 1, 4, 2]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 4,
              aug: 3.05,
              sep: 3.1,
              oct: 3,
              nov: 3.22,
              total: 3.06,
              benchmark: 2.68,
              delta: 0.39,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [5, 2, 8, 4]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            },
            {
              rank: 5,
              aug: 3.45,
              sep: 3.39,
              oct: 3.36,
              nov: 3.23,
              total: 3.38,
              benchmark: 3.18,
              delta: 0.2,
              nested_rows: [
                {
                  rank: {
                    chart_options: {
                      credits: {
                        enabled: false
                      },
                      title: {
                        text: ''
                      },
                      legend: {
                        enabled: false
                      },
                      exporting: {
                        enabled: false
                      },
                      chart: {
                        width: 900,
                        height: 400
                      },
                      xAxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nov'],
                        title: {
                          text: ''
                        }
                      },
                      yAxis: {
                        title: {
                          text: ''
                        },
                        min: 0
                      },
                      series: [
                        {
                          name: '',
                          data: [10, 6, 4, 8]
                        }
                      ],
                      plotOptions: {
                        series: {
                          color: '#00008B'
                        }
                      }
                    }
                  }
                }
              ],
              property: 'M68981 BAY MINETTE, AL',
              hash_of_records: '1748'
            }
          ]
        }
      }
    },
    cstData: {
      columns: ['rank', 'property', 'No of records', 'Total', 'Benchmark', 'Delta', '2025-08', '2025-09', '2025-10'],
      metric_data: [
        [1, 'PUEBLO - I-25, CO', 101, 3, 2.39, 0.61, 1.95, 2.52, 3.31],
        [2, 'STOCKTON, CA', 58, 3.49, 3.53, -0.04, 5, 3.41, 3.27]
      ]
    },
    breakpoints: {
      xxl: '50%',
      xl: '50%',
      lg: '50%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    type: 'TOP_BOTTOM_TOPICS',
    title: 'Top and Bottom Topics',
    subTitle: 'Time Period: Current Year to Date | Reporting Date: Responsedate | Question: Overall Score',
    enableActionBtn: false,
    enableSwitchTab: true,
    switchOptions: ['TABLE', 'BAR'],
    colorRules: {
      ranges: [
        {
          min: 1,
          max: 999,
          color: '#8ACA90'
        },
        {
          min: 0,
          max: 1,
          color: '#E8F7EB'
        },
        {
          min: -1,
          max: 0,
          color: '#F5D6D6'
        },
        {
          min: -999,
          max: -1,
          color: '#E16067'
        }
      ]
    },
    cstDataV2: {
      top_topics: [
        {
          topic_label: 'Location - Convenience',
          impact_score: 84.81,
          topic_filter_query: {
            l1: 'Property/Facilities',
            l2: 'Property/Facilities - Location',
            l3: 'Location - Convenience'
          }
        },
        {
          topic_label: 'Helpfulness - General Staff',
          impact_score: 80.3,
          topic_filter_query: {
            l1: 'Staff',
            l2: 'Staff - Helpfulness',
            l3: 'Helpfulness - General Staff'
          }
        },
        {
          topic_label: 'Professionalism - General Staff',
          impact_score: 37.69,
          topic_filter_query: {
            l1: 'Staff',
            l2: 'Staff - Professionalism',
            l3: 'Professionalism - General Staff'
          }
        },
        {
          topic_label: 'Stay - Likelihood to recommend',
          impact_score: 28.85,
          topic_filter_query: {
            l1: 'Services',
            l2: 'Services - Stay',
            l3: 'Stay - Likelihood to recommend'
          }
        },
        {
          topic_label: 'Price/Value - Affordability',
          impact_score: 27.92,
          topic_filter_query: {
            l1: 'Services',
            l2: 'Services - Price/Value',
            l3: 'Price/Value - Affordability'
          }
        }
      ],
      bottom_topics: [
        {
          topic_label: 'Room Functionality - HVAC',
          impact_score: -132.27,
          topic_filter_query: {
            l1: 'Guest Room',
            l2: 'Guest Room - Room Functionality',
            l3: 'Room Functionality - HVAC'
          }
        },
        {
          topic_label: 'Location - Guests Safety/Undesired Guests',
          impact_score: -82.47,
          topic_filter_query: {
            l1: 'Property/Facilities',
            l2: 'Property/Facilities - Location',
            l3: 'Location - Guests Safety/Undesired Guests'
          }
        },
        {
          topic_label: 'Room Condition - Overall Condition',
          impact_score: -64.34,
          topic_filter_query: {
            l1: 'Guest Room',
            l2: 'Guest Room - Room Condition',
            l3: 'Room Condition - Overall Condition'
          }
        },
        {
          topic_label: 'Room Odor - Smell',
          impact_score: -55.65,
          topic_filter_query: {
            l1: 'Guest Room',
            l2: 'Guest Room - Room Odor',
            l3: 'Room Odor - Smell'
          }
        },
        {
          topic_label: 'Room Functionality - Locks',
          impact_score: -49.88,
          topic_filter_query: {
            l1: 'Guest Room',
            l2: 'Guest Room - Room Functionality',
            l3: 'Room Functionality - Locks'
          }
        }
      ]
    },
    breakpoints: {
      xxl: '100%',
      xl: '100%',
      lg: '100%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  }
];

export const getPieChartDefaultData = () => {
  return {
    exporting: { enabled: false },
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      events: {},
      spacing: [0, 0, 0, 0],
      margin: [0, 0, 0, 0]
    },
    title: {
      text: ''
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false
        },
        center: ['50%', '50%']
      }
    },
    series: [],
    credits: {
      enabled: false
    }
  };
};

export const LOADER_GRID_DATA = [
  {
    data: [
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      { height: 52, flex: 1 },
      { height: 52, flex: 1 },
      { height: 52, flex: 1 },
      { height: 52, flex: 1 }
    ],
    breakpoints: {
      xxl: '33%',
      xl: '33%',
      lg: '33%',
      md: '50%',
      sm: '50%',
      xs: '100%'
    }
  },
  {
    data: [
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      { height: 52, flex: 1 },
      { height: 52, flex: 1 },
      { height: 52, flex: 1 },
      { height: 52, flex: 1 }
    ],
    breakpoints: {
      xxl: '33%',
      xl: '33%',
      lg: '33%',
      md: '50%',
      sm: '50%',
      xs: '100%'
    }
  },
  {
    data: [
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      { height: 52, flex: 1 },
      { height: 52, flex: 1 },
      { height: 52, flex: 1 },
      { height: 52, flex: 1 }
    ],
    breakpoints: {
      xxl: '33%',
      xl: '33%',
      lg: '33%',
      md: '50%',
      sm: '50%',
      xs: '100%'
    }
  },

  {
    data: [
      { height: 52, flex: 1 },
      { height: 52, flex: 1 }
    ],
    breakpoints: {
      xxl: '100%',
      xl: '100%',
      lg: '100%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    data: [
      { height: 52, flex: 1, width: '50%' },
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ],
      [
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 },
        { height: 52, flex: 1 }
      ]
    ],
    breakpoints: {
      xxl: '100%',
      xl: '100%',
      lg: '100%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  },
  {
    data: [
      { height: 52, flex: 1 },
      { height: 103, flex: 1 },
      { height: 40, flex: 1 }
    ],
    breakpoints: {
      xxl: '100%',
      xl: '100%',
      lg: '100%',
      md: '100%',
      sm: '100%',
      xs: '100%'
    }
  }
];

export const ADDITIONAL_METRIX_OPTIONS = [
  { label: 'Percentage', value: 'percentage' },
  { label: 'Sample Size', value: 'sampleSize' }
];
